/* eslint-disable react/no-did-update-set-state */
import React from 'react';
import PropTypes from 'prop-types';
import {Spinner, Button} from '@ui-kitten/components';

class AppButton extends React.Component {
  constructor(props) {
    super();
    this.state = {
      title: props.title,
      status: props.status,
      size: props.size,
      appearance: props.appearance,
      style: props.style,
      onPress: props.onPress,
      loading: props.loading,
      loader: props.loader,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.loading !== this.props.loading) {
      //Perform some operation here
      this.setState({loading: this.props.loading});
    }
  }

  handleOnPress = () => {
    this.state.onPress();
  };

  render() {
    const {
      title,
      status,
      size,
      appearance,
      style,
      loader,
      loading,
    } = this.state;

    return (
      <Button
        style={style}
        status={status}
        appearance={appearance}
        size={size}
        onPress={this.handleOnPress}
        disabled={loading}>
        {loader && loading && <Spinner status="primary" size="small" />}
        {!(loader && loading) && title}
      </Button>
    );
  }
}

AppButton.propTypes = {
  title: PropTypes.string,
  status: PropTypes.string,
  size: PropTypes.string,
  appearance: PropTypes.string,
  onPress: PropTypes.func,
  loading: PropTypes.bool,
};

AppButton.defaultProps = {
  loading: false,
  title: 'button',
  status: 'primary',
  size: 'large',
  appearance: 'filled',
  onPress: () => {},
};

export default AppButton;
